import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useResolutionScale } from '../../hooks';
import { SkipNextRounded } from '@mui/icons-material';
const CssButton = styled(Button)(({ theme }) => {
	const { scaleValue } = useResolutionScale();
	const isDark = theme.palette.mode === 'dark';

	const backgroundColor = isDark ? '#202020' : '#F8F8F8';
	const hoverBackgroundColor = isDark ? '#FFFFFF' : '#000000';

	const textColor = isDark ? '#202020' : '#F8F8F8';
	const hoverTextColor = isDark ? '#202020' : '#FFFFFF';

	const borderColor = isDark ? '#F8F8F8' : '#202020';

	const disabledBackground = isDark ? '#3A3A3A' : '#DADADA';
	const disabledTextColor = isDark
		? 'rgba(255, 255, 255, 0.3)'
		: 'rgba(0, 0, 0, 0.4)';

	return {
		'&&': {
			fontWeight: 700,
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
			alignItems: 'center',
			padding: `${scaleValue(13)}px ${scaleValue(32)}px`,
			gap: `${scaleValue(10)}px`,
			isolation: 'isolate',

			width: `${scaleValue(180)}px`,
			height: `${scaleValue(56)}px`,

			// background: backgroundColor,
			borderRadius: `${scaleValue(12)}px`,
			color: textColor,
			// border: `${scaleValue(1)}px solid ${borderColor}`,

			fontFamily: "'JLR Emeric', sans-serif",
			fontStyle: 'normal',
			fontSize: `${scaleValue(32)}px`,
			lineHeight: `${scaleValue(30)}px`,

			textTransform: 'none',
			boxShadow: 'none',
			zIndex: 0,
		},

		'&:hover': {
			background: hoverBackgroundColor,
			color: hoverTextColor,
			transform: `translateY(-${scaleValue(1)}px)`,
			boxShadow: `0px ${scaleValue(4)}px ${scaleValue(
				12,
			)}px rgba(0, 0, 0, 0.3)`,
			border: `${scaleValue(1)}px solid ${borderColor}`, // Keep same border
		},

		'&:active': {
			fontSize: `${scaleValue(36)}px`,
			transform: `translateY(${scaleValue(0)}px)`,
			boxShadow: `0px ${scaleValue(2)}px ${scaleValue(6)}px rgba(0, 0, 0, 0.2)`,
		},

		'&:focus-visible': {
			outline: `${scaleValue(2)}px solid ${borderColor}`,
			outlineOffset: `${scaleValue(2)}px`,
		},

		// '&.Mui-disabled': {
		// 	color: disabledTextColor,
		// 	background: disabledBackground,
		// 	cursor: 'not-allowed',
		// 	border: `${scaleValue(1)}px solid ${borderColor}`,
		// 	fontSize: `${scaleValue(32)}px`,
		// 	fontWeight: '1000 !important',
		// },

		// [theme.breakpoints.down('md')]: {
		// 	// width: `${scaleValue(200)}px`,
		// 	// height: `${scaleValue(50)}px`,
		// 	fontSize: `${scaleValue(20)}px`,
		// 	lineHeight: `${scaleValue(26)}px`,
		// },

		// [theme.breakpoints.down('sm')]: {
		// 	// width: `${scaleValue(180)}px`,
		// 	// height: `${scaleValue(48)}px`,
		// 	fontSize: `${scaleValue(18)}px`,
		// 	lineHeight: `${scaleValue(24)}px`,
		// 	padding: `${scaleValue(10)}px ${scaleValue(16)}px`,
		// },
	};
});

export const LargeButton = ({
	name,
	backgroundColor,
	handleButtonClick,
	...otherProps
}) => {
	// Check if this is a View Report button
	const isViewReport = name && name.toLowerCase().includes('view report');
	const { scaleValue } = useResolutionScale();

	return (
		<>
			<CssButton
				backgroundColor={backgroundColor}
				isViewReport={isViewReport}
				onClick={handleButtonClick}
				{...otherProps}
			>
				<SkipNextRounded sx={{
					fontSize: `${scaleValue(32)}px`
				}}/>
				{name}
			</CssButton>
		</>
	);
};

LargeButton.propTypes = {
	name: PropTypes.string.isRequired,
	backgroundColor: PropTypes.string,
	handleButtonClick: PropTypes.func,
	onClick: PropTypes.func,
};

export default LargeButton;
